import React, {Component} from 'react';
import Data from "./Data";
import $ from "jquery";
import axios from "axios";
import ModalAddClass from "./ModalAddClass";
import ModalEditMaster from "./ModalEditMaster";
import { th } from 'date-fns/locale';

class MastersList extends Component {

    constructor(props) {
        super(props);
        this.state={
            modaladdclass: <div />
        }
    }

    collapse(id){
        $('#'+id).collapse('toggle');
    }
    handleDelete(id,modalid,studentid){

        $('#'+modalid).modal('hide');
        $('#waitspinner').modal('show');

        let token = localStorage.getItem('token');
        let data = new FormData();
        data.append('token', '');
        data.append('id', id);
        axios.post(Data.server+`deleteMaster.php`,data)
            .then(response => {
                $('#waitspinner').each(function (){
                    $(this).modal('hide');
                });
                if (response.data === 'ok') {
                    this.props.length();
                    this.props.toast("استاد با موفقیت حذف شد.","3000","bg-primary",()=> {
                        $('#'+studentid).addClass('animate__animated animate__fadeOut disabled');
                        $('#'+studentid).on('animationend',function (){
                            $(this).remove();
                        });

                        $('#liveToast').toast('show');
                    });
                }
                if (response.data === 'wrong id') {
                    this.props.toast("خطا : شناسه هنرجو اشتباه است","3000","bg-danger",()=> {

                        $('#liveToast').toast('show');
                    });
                }
                if (response.data.hasOwnProperty('no_item')) {
                    $('#no_item').removeClass('invisible');

                }
            })
            .catch(error => {
                console.log(error)
            });

    }

    handleAddClass(e,addclassmodalid,masterid,products,index){
        this.setState({
            modaladdclass: <ModalAddClass
            toast={this.props.toast.bind(this)}
            id={addclassmodalid}
            masterid={masterid}
            products={products}
            index={index} />
        }, () => {
            $('#'+addclassmodalid).modal('show');
        });
    }
    render() {
        const {products,index} = this.props;
        const {modaladdclass} = this.state;
        let masterid = 'master'+index;
        let deletemodalid = 'deletemaster'+index;
        let editmodalid = 'editmaster'+index;
        let addclassmodalid = 'addclass'+index;

        let pic = <img id={"masterimg"+index} className="circle-icon" style={{zIndex:'999'}} width="64px" height="64px"
                       src={products['picture']===''?Data.mainserver+"icons/user.png":Data.mainserver + "images/" + products['picture']}/>

        let ins = "";
        if (products['instruments'].length > 0){
            ins = products['instruments'][0]['name'];
            for (let i = 0;i<products['instruments'].length;i++){
                if (i > 0){
                    ins += ' , '+products['instruments'][i]['name'];
                }
            }
        }
        let day = "";
        if (products['days'].length > 0){
            day = products['days'][0]['day'];
            for (let i = 0;i<products['days'].length;i++){
                if (i > 0){
                    day += ' , '+products['days'][i]['day'];
                }
            }
        }

        return (
            <tr id={masterid} key={index} className="text-center">

                <td>{pic}</td>
                <td>{products['name']}</td>
                <td>{products['userid']}</td>
                <td>{products['phone']}</td>
                <td>{products['bio']}</td>
                <td><small>{ins}</small>{products['instruments'].map((d,i) => <img key={i} className="mr-2" height="20px" width="20px" src={Data.server+"icons/"+d['icon']}/>)}</td>
                <td><small>{day}</small></td>
                <td>
                    <div className="btn-group" role="group" aria-label="Basic example">
                        <button 
                        type="button" 
                        className="btn btn-sm btn-outline-success" 
                        onClick={(e) => this.handleAddClass(e,addclassmodalid,masterid,products,index)}
                        data-toggle="modal"
                        data-target={"#"+addclassmodalid}>تعریف کلاس</button>
                        <button type="button" className="btn btn-sm btn-outline-info" data-toggle="modal" data-target={"#"+editmodalid}>ویرایش</button>
                        <button type="button" className="btn btn-sm btn-outline-danger" data-toggle="modal" data-target={"#"+deletemodalid}>حذف</button>
                    </div>
                    
                    {modaladdclass}

                    <ModalEditMaster
                        toast={this.props.toast.bind(this)}
                        id={editmodalid}
                        masterid={masterid}
                        products={products}
                        index={index} />
                        
                    <div className="modal fade" id={deletemodalid} tabIndex="-1" aria-labelledby={deletemodalid+"Label"}
                         aria-hidden="true">
                        <div className="modal-dialog modal-dialog-scrollable modal-sm modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h6 className="modal-title" id={deletemodalid+"Label"}>{"حذف "+products['name']}</h6>
                                    <button type="button" className="close text-left ml-0" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    {"آیا از حذف استاد "+products['name']+" مطمئن هستید ؟"}
                                    <br />
                                    <strong>{"با این کار تمام کلاس های مربوط به ایشان پاک خواهد شد"}</strong>
                                </div>
                                <div className="modal-footer">
                                    <div className="btn-group">
                                        <button type="button" className="btn btn-danger" data-dismiss="modal" onClick={() => this.handleDelete(products['id'],deletemodalid,masterid)}>بله</button>
                                        <button type="button" className="btn btn-secondary" data-dismiss="modal">خیر</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </td>
            </tr>

        );
    }
}


export default MastersList;
